'use strict';

goog.provide("Ntry.SystemManager");

Ntry.SystemManager = function() {
    this._systems = [];
    this.frameCount = 0;
};

(function(p){
    p.removeAllSystem = function() {
        this._systems.forEach(function (system) {
            if('remove' in system) {
                system.remove();
            }
        });
        this._systems = [];
    }

    p.addSystem = function(system) {
        var system = new system();
        this._systems.push(system);
    };

    p.update = function() {
        this.frameCount++;
        for (var i in this._systems) {
            var system = this._systems[i];
            if (system.update)
                system.update(this.frameCount);
        }
    };

    p.updateConfig = function() {
        for (var i in this._systems) {
            var system = this._systems[i];
            if (system.loadConfig)
                system.loadConfig();
        }
    };

})(Ntry.SystemManager.prototype);
